
import { useState, useEffect, useMemo } from "react";
import Fuse from "fuse.js";

const POPULAR_CITIES = ["Mumbai", "Delhi", "Bangalore", "Hyderabad", "Chennai", "Pune"];

export function useCitySearch(cities) {
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredCities, setFilteredCities] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);

  // Initialize Fuse.js for fuzzy search
  const fuse = useMemo(() => {
    if (!cities || cities.length === 0) return null;
    
    return new Fuse(cities, {
      keys: ["name", "state"],
      threshold: 0.3,
      includeScore: true,
    });
  }, [cities]);

  useEffect(() => {
    if (!cities || cities.length === 0) {
      setFilteredCities([]);
      return;
    }

    if (!searchQuery.trim()) {
      // When search is empty, show popular cities first (up to 6), then others (limit total to 20)
      const popular = cities.filter((city) =>
        POPULAR_CITIES.includes(city.name)
      ).slice(0, 6);
      
      const others = cities
        .filter((city) => !POPULAR_CITIES.includes(city.name))
        .slice(0, 20 - popular.length);
      
      setFilteredCities([...popular, ...others]);
    } else {
      // Use Fuse.js for fuzzy search and limit to 20 results
      if (fuse) {
        const results = fuse.search(searchQuery).slice(0, 20);
        setFilteredCities(results.map((result) => result.item));
      }
    }
  }, [searchQuery, cities, fuse]);

  return {
    searchQuery,
    setSearchQuery,
    filteredCities,
    showDropdown,
    setShowDropdown,
  };
}
